import { render, staticRenderFns } from "./Filiale.vue?vue&type=template&id=509ede12"
import script from "./Filiale.vue?vue&type=script&lang=ts"
export * from "./Filiale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports